import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import ChromeIcon from 'lib/images/ChromeIcon';
import MozillaIcon from 'lib/images/MozillaIcon';
import CovideoWithSquareBackground from '../../../../../lib/images/CovideoWithSquareBackground';

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  padding: 32px;
  width: 800px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.palette.lightgray};
  border-radius: 4px;
  margin-top: 32px;
  > span {
    opacity: 0.7;
  }
`;

const Button = styled.a`
  height: 40px;
  background-color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
  display: inline-block;
  padding: 2px 8px;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  span {
    margin-left: 4px;
  }
  &:hover {
    background-color: ${theme.palette.buttonPrimaryHover};
  }
  .background {
    fill: inherit;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  width: 330px;
  justify-content: space-between;
`;

export const IncompatibleSafari = () => {
  return (
    <MainDiv>
      <Content>
        <span>
          Currently, our web-based recorder is only compatible with Google
          Chrome and Mozilla Firefox.
        </span>

        <span>You can download each of them using the buttons below.</span>

        <ButtonContainer>
          <Button
            href='https://www.google.com/chrome/'
            className='btn btn-primary btn-download'
            target='_blank'
          >
            <ChromeIcon color='#fff' />
            <span>Google Chrome</span>
          </Button>
          <Button
            href='https://www.mozilla.org/en-US/firefox/new/'
            className='btn btn-primary btn-download'
            target='_blank'
          >
            <MozillaIcon color='#fff' />
            <span>Mozilla Firefox</span>
          </Button>
        </ButtonContainer>
      </Content>

      <Content>
        <span>
          We also offer recording software you can install on Windows, Mac, iOS,
          and Android using the button below.
        </span>

        <Button href='/integrations' className='btn btn-primary btn-download'>
          <CovideoWithSquareBackground color='#fff' width={36} height={36} />
          <span>Download Covideo</span>
        </Button>
      </Content>
    </MainDiv>
  );
};
